import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
import { paginationMetaSchema } from './pagination.js';
export const searchEntityTypeSchema = z.enum([
    'CUSTOMER',
    'SUPPLIER',
    'CONTACT',
    'ADDRESS',
    'PRODUCT',
    'CATEGORY',
    'DOCUMENT',
    'LEGACY_DOCUMENT',
    'PURCHASE_ORDER',
    'GOODS_RECEIPT',
    'BATCH',
    'DMS_DOCUMENT',
    'ACTIVITY',
    'CALL',
    'EMAIL',
]);
export const globalSearchQuerySchema = z.object({
    q: z.string().trim().max(160).default(''),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(40).default(20),
    entityTypes: z.preprocess((value) => typeof value === 'string'
        ? value
            .split(',')
            .map((entry) => entry.trim())
            .filter(Boolean)
        : value, z.array(searchEntityTypeSchema).max(searchEntityTypeSchema.options.length).optional()),
});
export const globalSearchResultSchema = z.object({
    searchIndexId: idSchema,
    entityType: searchEntityTypeSchema,
    entityId: idSchema,
    title: z.string(),
    subtitle: z.string().nullable(),
    route: z.string().startsWith('/'),
    metadata: z.record(z.unknown()),
    score: z.number().finite().min(0),
    updatedAt: isoDateTimeSchema,
    isRecent: z.boolean(),
});
export const globalSearchResponseSchema = z.object({
    data: z.array(globalSearchResultSchema),
    meta: paginationMetaSchema,
    query: z.string(),
});
export const recentSearchRecordRequestSchema = z.object({
    searchIndexId: idSchema,
});
export const recentSearchRecordResponseSchema = z.object({
    recorded: z.literal(true),
});
//# sourceMappingURL=search.js.map